'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
class $c_jl_StringIndexOutOfBoundsException extends $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException {
  constructor() {
    super();
    $j_java$002elang$002e$002dObject.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
export { $c_jl_StringIndexOutOfBoundsException as $c_jl_StringIndexOutOfBoundsException };
var $d_jl_StringIndexOutOfBoundsException = new $j_java$002elang$002e$002dObject.$TypeData().i($c_jl_StringIndexOutOfBoundsException, "java.lang.StringIndexOutOfBoundsException", ({
  kn: 1,
  cb: 1,
  R: 1,
  Q: 1,
  H: 1,
  a: 1
}));
export { $d_jl_StringIndexOutOfBoundsException as $d_jl_StringIndexOutOfBoundsException };
